import { useEffect } from "react";

import { track } from "../../analytics";
import { PAST_EVENTS } from "../../content/eventsArchive";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Mahamandir } from "../../ui/Mahamandir";
import { Masters } from "../../ui/Masters";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

import { UpcomingBlock, WeeklySessions } from "./UpcomingBlock";

export function EventsPage() {
  useEffect(() => {
    track("events_viewed");
  }, []);
  return (
    <Page title="Events" heading="Events">
      <Section
        id="upcoming"
        eyebrow="Upcoming"
        lede="Four programmes in the visit of Swamiji and Sarkar: two by invitation, two open to everyone with one registration."
      >
        <Masters className="mb-10 max-w-xl" />
        <UpcomingBlock full />
        <Mahamandir className="mt-14" />
      </Section>

      <Section id="weekly" title="Weekly sessions" tone="ivory-deep">
        <WeeklySessions />
      </Section>

      <Section id="past" title="Past events">
        <ul role="list" className="flex flex-col gap-4">
          {PAST_EVENTS.map((e) => (
            <li key={`${e.title}-${e.date}`}>
              <Reveal className="flex flex-col items-start gap-3 rounded-lg border border-hairline bg-card p-5 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h3 className="font-display text-lg text-ink">{e.title}</h3>
                  <p className="mt-1 text-sm text-ink-soft">{e.date}</p>
                </div>
                <Button href={e.href} variant="secondary" size="md">
                  {e.label}
                </Button>
              </Reveal>
            </li>
          ))}
        </ul>
      </Section>
    </Page>
  );
}
